import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxHero from '../features/parallax-hero';
import productGridReviews from '../features/product-grid';
import {quickviewSection} from '../features/quickview';
import popoutSection from '../features/popout';
import hideElement from '../util/hide-element';

var selectors = {
  sort: '[data-sort-enabled]',
  sortLinks: '[data-sort-link]',
  sortValue: 'data-value',
  collectionNavGrouped: '.collection-nav--grouped',
  collectionSidebarHeading: '.collection__sidebar__heading',
  linkAdd: '.link--add',
  linkRemove: '.link--remove',
};

class Collection {
  constructor(section) {
    this.container = section.container;
    this.sort = this.container.querySelector(selectors.sort);
    this.sortLinks = this.container.querySelectorAll(selectors.sortLinks);
    this.init();
  }

  init() {
    if (this.sort) {
      this.initClick();
    }
    this.removeUnusableFilters();
  }

  onClick(e) {
    const sort = e.currentTarget.getAttribute(selectors.sortValue);
    const url = new window.URL(window.location.href);
    const params = url.searchParams;
    params.set('sort_by', sort);
    url.search = params.toString();
    window.location.replace(url.toString());
  }

  initClick() {
    this.sortLinks.forEach((link) => {
      link.addEventListener(
        'click',
        function (e) {
          this.onClick(e);
        }.bind(this)
      );
    });
  }

  removeUnusableFilters() {
    const collectionNavGrouped = this.container.querySelectorAll(selectors.collectionNavGrouped);
    if (collectionNavGrouped.length > 0) {
      collectionNavGrouped.forEach((element) => {
        const linkAdd = element.querySelector(selectors.linkAdd);
        const linkRemove = element.querySelector(selectors.linkRemove);

        if (!linkAdd && !linkRemove) {
          hideElement(element);
          hideElement(element.parentElement.querySelector(selectors.collectionSidebarHeading));
        }
      });
    }
  }
}

const collectionSection = {
  onLoad() {
    this.collection = new Collection(this);
  },
  onUnload: function () {
    if (typeof this.collection.unload === 'function') {
      this.collection.unload();
    }
  },
};

register('collection', [parallaxHero, productGridReviews, quickviewSection, collectionSection, popoutSection]);
